import { forwardRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import IconButton from "../../../../components/IconButton";
import Tooltip from "../../../../components/Tooltip";
import PlayButton from "../../../../components/buttons/PlayButton";
import { validateContact } from "../../../../services-logic/company-directory/company-directory-logic";
import AccordionHeader from "../../../common-components/AccordionHeader";

const ContactsAccordionHeader = forwardRef(({ item, index, isActive, onSetAsDefault, onRemoveContact }, ref) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const updatedVoice = useSelector((state) => state.info.updatedVoice);
  const voices = useSelector((state) => state.info.voices);
  const selectedVoice = voices?.find((voice) => voice.id === updatedVoice);
  const { contactErrors } = useSelector((state) => state.companyDirectory);

  const validationMessage = () => {
    if (
      !contactErrors[index] ||
      Object.keys(contactErrors[index]).length === 0 ||
      Object.keys(contactErrors[index]).every((key) => contactErrors[index][key] === "")
    ) {
      return "";
    }

    const validation = validateContact(index, item);

    if (!validation.valid) {
      return "Required fields missing.";
    }
    return "";
  };

  const generateContactName = (contact) => {
    if (selectedVoice?.enablePreview === false) {
      return "";
    }

    if (contact.name) {
      return `Reaching ${contact.name}`;
    }
    return "";
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize());
  }, []);

  return (
    <AccordionHeader
      ref={ref}
      height="h-12"
      prefixIcon={"/assets/icons/common/contact.svg"}
      suffixIcon={item.isDefault ? "/assets/icons/actions/v2/star-hover.svg" : ""}
      suffixIconToolTipMessage={item.isDefault ? "Remove as default" : "Set as default"}
      title={`${item.name}`}
      subtitle={
        item.dtmfShortcutKey
          ? `(Speed dial key: ${item.isDefault ? "0," : ""}${item.dtmfShortcutKey})`
          : item.isDefault
          ? "(Speed dial key: 0)"
          : ""
      }
      isActive={isActive}
      validationMessage={validationMessage()}
      actionsChildren={
        <div className="flex gap-2 justify-center items-center">
          <Tooltip
            text="Default contact is the assigned contact for calls when the caller unsure who they want to reach or when the Smart Receptionist cannot resolve their request, guaranteeing no call goes unattended."
            direction={isMobile ? "bottom" : "left"}
          >
            <IconButton
              iconSize="size-5"
              icon={item.isDefault ? "/assets/icons/actions/v2/star-hover.svg" : "/assets/icons/actions/v2/star.svg"}
              hoverIcon={"/assets/icons/actions/v2/star-hover.svg"}
              onClick={(event) => {
                event?.stopPropagation();
                onSetAsDefault(item.isDefault ? null : index);
              }}
            />
          </Tooltip>
          <PlayButton
            voice={selectedVoice?.id}
            id={`contact-${index}`}
            text={generateContactName(item)}
            iconSize="size-5"
            preventPropagation={isActive}
          />
          <IconButton
            iconSize="size-5"
            icon={"/assets/icons/actions/delete.svg"}
            hoverIcon={"/assets/icons/actions/delete-hover.svg"}
            onClick={(event) => {
              event?.stopPropagation();
              onRemoveContact(index);
            }}
          />
        </div>
      }
    />
  );
});

export default ContactsAccordionHeader;
